import { GET_POPULAR_DESTINATIONS } from './types';

export const getPopularDestinations = (popularDestinations) => ({
  type: GET_POPULAR_DESTINATIONS,
  payload: popularDestinations,
});
